import { effect, signal } from '@preact/signals'
import { LogOut, Moon, Sun } from 'lucide-preact'
import { Breadcrumbs } from './ui/breadcrumbs.tsx'
import { Logo } from './lib/icon.tsx'
import { A, url } from '@01edu/signal-router'
import { user } from './lib/session.ts'

const $theme = signal(localStorage.theme || 'dark')

effect(() => {
  document.documentElement.dataset.theme = $theme.value
  localStorage.theme = $theme.value
})

const toggleTheme = () => {
  $theme.value = $theme.peek() === 'dark' ? 'light' : 'dark'
}

const UserInfo = () => {
  if (!user.data) return null

  return (
    <div class='flex items-center gap-2'>
      <div class='flex items-center gap-10'>
        <span class='text-sm text-center font-medium select-none'>
          {user.data.userFullName}
        </span>

        {user.data && (
          <A href='/api/logout' class='text-sm whitespace-nowrap'>
            <span class='underline'>Logout</span>{' '}
            <LogOut size='16' class='inline-block' />
          </A>
        )}
      </div>
      {user.data.userPicture && (
        <img
          src={`/api/picture?hash=${user.data.userPicture}`}
          alt='profile picture'
          class='w-12 h-12 rounded-full pointer-events-none'
        />
      )}
    </div>
  )
}

export const SwitchTheme = () => (
  <label class='swap swap-rotate'>
    <input
      type='checkbox'
      class='theme-controller'
      checked={$theme.value === 'dark'}
      onInput={toggleTheme}
    />
    <Moon class='swap-on h-7 w-7' />
    <Sun class='swap-off h-7 w-7' />
  </label>
)

export const Footer = () => (
  <footer class='sticky bottom-0 py-3 bg-base-100 border-t border-base-300'>
    <div class='max-w-375 mx-auto px-6 flex justify-center items-center gap-4'>
      <div class='flex items-center gap-3'>
        <Logo
          size={36}
          primary={$theme.value === 'dark' ? '#fff' : '#000'}
          secondary='#26F'
        />
        <p class='text-base-content text-sm'>
          © {new Date().getFullYear()} - All rights reserved
        </p>
      </div>
    </div>
  </footer>
)

export const Header = () => (
  <header class='sticky top-0 z-50 bg-base-100 border-b border-base-300 px-6 lg:px-10 py-3'>
    <div class='max-w-375 mx-auto flex items-center justify-between'>
      <div class='flex items-center gap-4'>
        <A
          href='/'
          params={Object.fromEntries(
            Object.keys(url.params).map((k) => [k, null]),
          )}
          class='flex items-center gap-2 hover:opacity-80 transition-opacity'
        >
          <div class='size-8 text-primary'>
            <Logo
              size={36}
              primary={$theme.value === 'dark' ? '#fff' : '#000'}
              secondary='#26F'
            />
          </div>
          <p class='text-xl font-bold'>LICENSE HUB</p>
        </A>
        <Breadcrumbs />
      </div>

      <div class='flex items-center gap-10'>
        <SwitchTheme />
        {!['/verify-invitation', '/verify-login'].includes(url.path) && (
          <UserInfo />
        )}
      </div>
    </div>
  </header>
)
